import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function InterventionPointDeployments() {
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(true);
  // No data yet: keep count as "--"
  const count = '--';

  return (
    <div className="rounded border border-gray-200">
      <div className="flex items-center justify-between border-b px-3 py-2">
        <div className="flex items-center gap-2">
          <div className="text-sm font-medium text-gray-700">{t('Remerchandising history')}</div>
          <span className="inline-flex items-center rounded-full bg-gray-100 text-gray-800 text-[10px] px-2 py-0.5">
            {count}
          </span>
        </div>
        <button
          type="button"
          onClick={() => setCollapsed(s => !s)}
          className="text-xs text-gray-600 hover:text-gray-900"
        >
          {collapsed ? t('Show') : t('Hide')}
        </button>
      </div>
      {!collapsed && (
        <div className="p-3">
          <div className="flex items-center justify-center py-6">
            <div className="flex items-center gap-3 rounded-md border border-dashed border-gray-300 bg-gray-50 px-4 py-3">
              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div>
                <div className="text-sm font-medium text-gray-700">{t('Coming soon')}</div>
                <div className="text-xs text-gray-500">{t('Remerchandising history')}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


